import { useState, useEffect } from 'react';

const UseWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: null,
    height: null,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          isMobile: window.innerWidth < 768,
          isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
          isDesktop: window.innerWidth >= 1024
        });
      };

      // Initialize window size on first load
      handleResize();

      window.addEventListener('resize', handleResize, {passive: true});

      // Cleanup on component unmount
      return () => {
        window.removeEventListener('resize', handleResize, {passive: true});
      };
    }
  }, []); // Remove `window` dependency to avoid SSR issues

  return windowSize;
};

export default UseWindowSize;
